import React from 'react';
import { formatDate, formatDateTime } from 'src/utils/date';

type CellProps = {
  dataItem: any;
  field?: string;
};

export const DateCell: React.FC<CellProps> = props => {
  const { dataItem, field } = props;
  return (
    <td>{field && dataItem[field] && formatDate(new Date(dataItem[field]))}</td>
  );
};

export const DateTimeCell: React.FC<CellProps> = props => {
  const { dataItem, field } = props;
  return (
    <td>
      {field && dataItem[field] && formatDateTime(new Date(dataItem[field]))}
    </td>
  );
};
